import Vuex from 'vuex';
import state from './state.js'
import actions from './actions.js'
import mutations from './mutations.js'
import getters from './getters.js'
import Vue from 'vue';
Vue.use(Vuex)

export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters
})
